export const resolvePromise = resolveValue => {
  return Promise.resolve(resolveValue);
};

export const rejectPromise = rejectValue => {
  return Promise.reject(rejectValue);
};
